export const tabs = [
  { id: "1", title: "Summary" },
  { id: "2", title: "Milestones" },
  { id: "3", title: "Budgets" },
  { id: "4", title: "Payment Groups" },
  { id: "5", title: "Review" },
];

export default tabs;

export const statusStyleArray = [
  {
    status: "STANDARD",
    color: "#d46b08",
    backgroundColor: "#fff7e6",
  },
  {
    status: "ECONOMIC",
    color: "#096dd9",
    backgroundColor: "#e6f7ff",
  },
  {
    status: "awaiting-contractor-confirmation",
    color: "#c41d7f",
    backgroundColor: "#fff0f6",
  },
  {
    status: "SUPER HIGH END",
    color: "#389e0d",
    backgroundColor: "#f6ffed",
  },
  {
    status: "Requested",
    backgroundColor: "#096dd9",
    color: "#e6f7ff",
  },
  {
    status: "awaiting-approval",
    color: "#d4b106",
    backgroundColor: "#feffe6",
  },
  // {
  //   status: "awaiting-contractor-confirmation",
  //   backgroundColor: "#d46b08",
  //   color: "#fff7e6",
  // },
  {
    status: "proposed-to-client",
    color: "#fff",
    backgroundColor: "rgb(56, 158, 13)",
  },
  {
    status: "draft-by-contractor",
    backgroundColor: "#c41d7f",
    color: "#fff0f6",
  },
  {
    status: "rejected-by-contractor",
    color: "rgb(229, 71, 70)",
    backgroundColor: "#fff0f6",
  },
];

export const milestoneStatusStyleArray = [
  {
    status: "ongoing",
    backgroundColor: "#096dd9",
  },
  {
    status: "Not Started",
    color: "#c41d7f",
    backgroundColor: "#fff0f6",
  },
  {
    status: "delivered",
    backgroundColor: "#389e0d",
  },
  {
    status: "pending",
    backgroundColor: "#d46b08",
  },
  {
    status: "completed",
    backgroundColor: "rgb(56, 158, 13)",
  },
  { status: "change_request", backgroundColor: "#c41d7f" },
  { status: "due", backgroundColor: "#c41d7f" },
  { status: "closed", backgroundColor: "red" },
];